import {
    EDIT_CONTENT, DELETE_CONTENT, CREATE_CONTENT, CREATE_CONTENT_SUCCESS, UPDATE_CONTENT_SUCCESS,
    UPDATE_CONTENT, DELETE_CONTENT_SUCCESS, FETCH_ALL_CONTENT, FETCH_ALL_CONTENT_SUCCESS,SET_CONTENT
  } from 'constants/contents.constants'
import { startLoader } from 'actions/general.action';

export const setContent = (key, value) => {
    return {
      type : SET_CONTENT,
      key: key,
      value: value
    }
}

export const fetchContents = (page) => {
    return dispatch => {
      dispatch({
        type: FETCH_ALL_CONTENT,
        payload: page
      })
      dispatch(startLoader())
    }
  }
  
  export const fetchContentsSuccess = (data) => {
    return {
      type: FETCH_ALL_CONTENT_SUCCESS,
      payload: data
    };
  };
  
  export const deleteContent = (id) => {
    return {
      type: DELETE_CONTENT,
      payload: id
    };
  };
  
  export const editContent = (id) => {
    return {
      type: EDIT_CONTENT,
      payload: id
    };
  };
  
  export const createContent = (payload) => {
    console.log(payload)
    return {
      type: CREATE_CONTENT,
      payload: payload
    };
  };
  
  export const createContentSuccess = (payload) => {
    return {
      type: CREATE_CONTENT_SUCCESS,
      payload: payload
    };
  };
  
  export const updateContentSuccess = (data) => {
    return {
      type: UPDATE_CONTENT_SUCCESS,
      payload: data
    };
  };
  
  export const deleteContentSuccess = (data) => {
    return {
      type: DELETE_CONTENT_SUCCESS,
      payload: data
    };
  };
  
  export const updateContent = (payload) => {
    return {
      type: UPDATE_CONTENT,
      payload: payload
    };
  }; 